<template>
  <div id="app">
    <AppBar />
    <router-view/>
    <BottomNav />

  </div>
</template>

<script>
import AppBar from './components/AppBar.vue'
import BottomNav from './components/BottomNav.vue'

export default {
  name: 'App',
  components: {
    AppBar,
    BottomNav
  }
}
</script>

<style>
body {
  font-family: 'Arial', sans-serif;
  margin: 0
}
#app {
  display: flex;
  flex-direction: column;
  min-height: 100vh; 
}

router-view {
  flex: 1; /* Allow main content to take remaining space */
}

.bottom-nav {
  position: fixed; /* Fixes the position at the bottom */
  bottom: 0;
  width: 100%;
  background-color: #fff; /* Ensure background color */
  box-shadow: 0 -2px 5px rgba(0, 0, 0, 0.1); /* Optional: Add shadow for better visibility */
  z-index: 1000; /* Make sure it's above other content */
}
</style>

